var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "corporation" },
    [
      _c("nos-component", {
        ref: "NOS_COMPONENT",
        attrs: { component: this.NOS_INSTANCE.components }
      }),
      _c(
        "div",
        { staticClass: "scroll" },
        [
          _c("contents-header", {
            attrs: {
              "bg-type": true,
              title: "MCOP-01-01-07-01",
              description: "MCOP-01-01-07-02"
            }
          }),
          _c("article", { staticClass: "contents" }, [
            _c("div", { staticClass: "form" }, [
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "ovsesCustOcntryName",
                    attrs: {
                      id: "ovsesCustOcntryName",
                      value: _vm.RBF0409E40_data.ovsesCustOcntryName,
                      disabled: "",
                      "label-i18n": "MCOP-01-01-07-03"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "coTelno",
                    attrs: {
                      id: "coTelno",
                      value: _vm.RBF0409E40_data.coTelno,
                      disabled: "",
                      "label-i18n": "MCOP-01-01-07-04"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "faxNo",
                    attrs: {
                      id: "faxNo",
                      value: _vm.RBF0409E40_data.faxNo,
                      disabled: "",
                      "label-i18n": "MCOP-01-01-07-05"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "item-tit" }, [
                  _vm._v(_vm._s(/*법인소재지주소*/ _vm.$t("MCOP-01-01-07-06")))
                ]),
                _c(
                  "div",
                  { staticClass: "item-desc" },
                  [
                    _vm.RBF0409E40_data.coprNmad
                      ? _c("input-text", {
                          ref: "coprNmad",
                          attrs: {
                            id: "coprNmad",
                            value: _vm.RBF0409E40_data.coprNmad,
                            disabled: ""
                          }
                        })
                      : _vm._e(),
                    _c("input-text", {
                      ref: "coprAddr1",
                      attrs: {
                        id: "coprAddr1",
                        value: _vm.RBF0409E40_data.coprAddr1,
                        disabled: ""
                      }
                    }),
                    _vm.RBF0409E40_data.coprAddr2
                      ? _c("input-text", {
                          ref: "coprAddr2",
                          attrs: {
                            id: "coprAddr2",
                            value: _vm.RBF0409E40_data.coprAddr2,
                            disabled: ""
                          }
                        })
                      : _vm._e(),
                    _vm.RBF0409E40_data.coprAddr3
                      ? _c("input-text", {
                          ref: "coprAddr3",
                          attrs: {
                            id: "coprAddr3",
                            value: _vm.RBF0409E40_data.coprAddr3,
                            disabled: ""
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "rprsOcntryName",
                    attrs: {
                      id: "rprsOcntryName",
                      value: _vm.RBF0409E40_data.rprsOcntryName,
                      disabled: "",
                      "label-i18n": "MCOP-01-01-07-07"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "cphnNo",
                    attrs: {
                      id: "cphnNo",
                      value: _vm.RBF0409E40_data.cphnNo,
                      disabled: "",
                      "label-i18n": "MCOP-01-01-07-08"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "exno",
                    attrs: {
                      id: "exno",
                      value: _vm.RBF0409E40_data.exno,
                      disabled: "",
                      "label-i18n": "MCOP-01-01-07-09"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "rprsEmad1",
                    attrs: {
                      id: "rprsEmad1",
                      value: _vm.RBF0409E40_data.rprsEmad1,
                      disabled: "",
                      "label-i18n": "MCOP-01-01-07-10"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "item-tit" }, [
                  _vm._v(_vm._s(/*대표자 주소*/ _vm.$t("MCOP-01-01-07-11")))
                ]),
                _c(
                  "div",
                  { staticClass: "item-desc" },
                  [
                    _vm.RBF0409E40_data.rprsNmad
                      ? _c("input-text", {
                          ref: "rprsNmad",
                          attrs: {
                            id: "rprsNmad",
                            value: _vm.RBF0409E40_data.rprsNmad,
                            disabled: ""
                          }
                        })
                      : _vm._e(),
                    _c("input-text", {
                      ref: "rprsAddr1",
                      attrs: {
                        id: "rprsAddr1",
                        value: _vm.RBF0409E40_data.rprsAddr1,
                        disabled: ""
                      }
                    }),
                    _vm.RBF0409E40_data.rprsAddr2
                      ? _c("input-text", {
                          ref: "rprsAddr2",
                          attrs: {
                            id: "rprsAddr2",
                            value: _vm.RBF0409E40_data.rprsAddr2,
                            disabled: ""
                          }
                        })
                      : _vm._e(),
                    _vm.RBF0409E40_data.rprsAddr3
                      ? _c("input-text", {
                          ref: "rprsAddr3",
                          attrs: {
                            id: "rprsAddr3",
                            value: _vm.RBF0409E40_data.rprsAddr3,
                            disabled: ""
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "postSendAreaDstcd",
                    attrs: {
                      id: "postSendAreaDstcd",
                      value: _vm.$te(
                        _vm.RBF0409E40_data.postSendAreaDstcd +
                          "_우편발송지구분코드"
                      )
                        ? _vm.$t(
                            _vm.RBF0409E40_data.postSendAreaDstcd +
                              "_우편발송지구분코드"
                          )
                        : "",
                      disabled: "",
                      "label-i18n": "MCOP-01-01-07-12"
                    }
                  })
                ],
                1
              ),
              _vm.siteCode === _vm.$config.SITECODE_OGAUC
                ? _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c("input-text", {
                        ref: "postSendYn",
                        attrs: {
                          id: "postSendYn",
                          value: _vm.$te(
                            _vm.RBF0409E40_data.postSendYn + "_우편발송여부"
                          )
                            ? _vm.$t(
                                _vm.RBF0409E40_data.postSendYn + "_우편발송여부"
                              )
                            : "",
                          disabled: "",
                          "label-i18n": "MCOP-01-01-07-14"
                        }
                      }),
                      _vm.siteCode === _vm.$config.SITECODE_OGAUC
                        ? _c("div", { staticClass: "info info-etc" }, [
                            _vm._v(
                              "※ " +
                                _vm._s(
                                  /*조회 > 거래내역조회 > Statement조회 에서 조회 후 인쇄할 수 있습니다.*/ _vm.$t(
                                    "MCOP-01-01-07-16"
                                  )
                                )
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "notice notice-box--type" }, [
              _c("div", { staticClass: "notice-tit" }, [
                _c("p", { staticClass: "bullet" }, [
                  _vm._v(_vm._s(/*유의사항*/ _vm.$t("MCOP-01-01-07-17")))
                ])
              ]),
              _c("div", { staticClass: "notice-cont" }, [
                _c("ul", { staticClass: "ulist bar" }, [
                  _c("li", [
                    _vm._v(
                      "- " +
                        _vm._s(
                          /*잘못된 정보로 인한 우편물 반송에 대한 책임은 당사자가 지지 않습니다.*/ _vm.$t(
                            "MCOP-01-01-07-18"
                          )
                        )
                    )
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c("div", { staticClass: "btn-area--full fixed" }, [
        _c(
          "button",
          { staticClass: "btn md normal", on: { click: _vm.goNextStep } },
          [_vm._v(_vm._s(/*확인*/ _vm.$t("MCOM-0000003")))]
        )
      ]),
      _c("approval-line", {
        ref: "otp",
        attrs: { NOS_INSTANCE_REFERANCE: _vm.NOS_INSTANCE },
        on: { authOpen: _vm.confirmOtp }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }